import React from "react";
import { Navigate } from "react-router-dom";

import BasicTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify';
import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";

// Authentication
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import ChangePass from "../pages/AuthenticationInner/PasswordReset/ChangePass";
import EmailVerify from "../pages/Authentication/EmailVerify";

// Dashboard
import Dashboard from "../pages/Dashboard";

// Demo Pages
import Demo1 from "../pages/Demo1";
// import Demo2 from "../pages/Demo2/Demo2";
import Demo2 from "../pages/Demo2";
import Demo3 from "../pages/Demo3";
import Chat from "../pages/Chat-bot";

import Chatbot from "../pages/Chat";
import DocumentList from "../pages/Documets";
import AnalysisPrediction from "../pages/AnalysisPrediction";

const authProtectedRoutes = [
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },

  // Dashboard
  { path: "/dashboard", component: <Dashboard /> },

  // Demo Pages
  { path: "/document-scanner", component: <Demo1 /> },
  { path: "/invoice-scanner", component: <Demo2 /> },
  { path: "/call-analyzer", component: <Demo3 /> },
  { path: "/chat", component: <Chat /> },
  { path: "/chatbot", component: <Chatbot /> },
  { path: "/documents", component: <DocumentList /> },
  { path: "/analysis-prediction", component: <AnalysisPrediction /> },

  // Authentication
  { path: "/verify-email", component: <EmailVerify /> },
  { path: "/change-password", component: <ChangePass /> },
];


const publicRoutes = [
  // Authentication Pages
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/twostep-verification", component: <BasicTwosVerify /> },
  { path: "/reset-password", component: <BasicPasswCreate /> },
];

export { authProtectedRoutes, publicRoutes };